import { request } from "../utils/request.js"

export const user_login = (pojo, args) => request({
    url: 'user/login',
    method: 'POST',
    params: pojo,
    ...args
})
export const user_changePassword = (pojo, args) => request({
    url: 'user/changePassword',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const user_findPageForManage = (pojo, args) => request({
    url: 'user/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const user_findPageForSelect = (pojo, args) => request({
    url: 'user/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const user_addNew = (pojo, args) => request({
    url: 'user/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const user_update = (pojo, args) => request({
    url: 'user/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const user_getCurrentUserInfo = (args) => request({
    url: 'user/getCurrentUserInfo',
    method: 'POST',
    showFailMessage: true,
    ...args
})

export const user_findById = (id, args) => request({
    url: 'user/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const user_delete = (id, args) => request({
    url: 'user/delete',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const user_changeFrozenStatus = (id, args) => request({
    url: 'user/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const user_resetPassword = (id, args) => request({
    url: 'user/resetPassword',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const user_addNewBatch = (pojo, args) => request({
    url: 'user/addNewBatch',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})




export const userLoginHistory_findByPageForCurrentUser = (pojo, args) => request({
    url: 'userLoginHistory/findByPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const userLoginHistory_findByPage = (pojo, args) => request({
    url: 'userLoginHistory/findByPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const user_selectOrg = (id, args) => request({
    url: 'user/selectOrg',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/user.js